/**
 * Project-level constants that appear in the UI.
 *
 * Kept in one file because a fork needs to change them, and hunting the repo URL
 * through a dozen JSX files is the kind of chore that stops people forking. Each
 * one can be overridden at build time so a fork does not have to edit source at
 * all — see `.env.example`.
 */

export const APP_NAME = 'LinkedIn Optimiser';

export const REPO_URL =
  import.meta.env.VITE_REPO_URL ?? 'https://github.com/Jagdish1998/linkedin-optimiser';

export const ISSUES_URL = `${REPO_URL}/issues`;

/**
 * The disclaimer is not boilerplate. This project analyses profiles on someone
 * else's platform using their field limits and terminology, so saying plainly
 * that it is unaffiliated is both honest and the thing that keeps it publishable.
 */
export const DISCLAIMER = 'Not affiliated with, endorsed by, or connected to LinkedIn Corporation.';
